export const paths = [
  "people",
  "planets",
  "films",
  "species",
  "vehicles",
  "starships",
];
